import { GraphQLScalarType, Kind } from "graphql";
const marathonYearRegex = /^DB\d{2}$/;
function isMarathonYearString(value) {
    return marathonYearRegex.test(value);
}
export const MarathonYearScalar = new GraphQLScalarType({
    name: "MarathonYear",
    description: "MarathonYear custom scalar type",
    extensions: {},
    parseValue(value) {
        if (typeof value === "string") {
            if (!isMarathonYearString(value)) {
                throw new TypeError("MarathonYearScalar can only parse strings that match the pattern DB00");
            }
            return value;
        }
        else {
            throw new TypeError("MarathonYearScalar can only parse strings");
        }
    },
    serialize(value) {
        if (typeof value === "string") {
            if (!isMarathonYearString(value)) {
                throw new TypeError("MarathonYearScalar can only serialize strings that match the pattern");
            }
            return value;
        }
        else {
            throw new TypeError("MarathonYearScalar can only serialize strings");
        }
    },
    parseLiteral(ast) {
        if (ast.kind === Kind.STRING) {
            if (!isMarathonYearString(ast.value)) {
                throw new TypeError("MarathonYearScalar can only parse literal string values that match the pattern");
            }
            return ast.value;
        }
        else {
            throw new TypeError("MarathonYearScalar can only parse literal string values");
        }
    },
});
//# sourceMappingURL=MarathonYear.js.map